module.exports = __webpack_public_path__ + "media/images/truck-f1303ad4cc8b78eca882739e4cc8aa74.svg";